import { render, staticRenderFns } from "./SensorBarChart.vue?vue&type=template&id=041676ff&scoped=true&"
import script from "./SensorBarChart.vue?vue&type=script&lang=js&"
export * from "./SensorBarChart.vue?vue&type=script&lang=js&"
import style0 from "./SensorBarChart.vue?vue&type=style&index=0&id=041676ff&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "041676ff",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/aims-dashboard/aims-dashboard/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('041676ff')) {
      api.createRecord('041676ff', component.options)
    } else {
      api.reload('041676ff', component.options)
    }
    module.hot.accept("./SensorBarChart.vue?vue&type=template&id=041676ff&scoped=true&", function () {
      api.rerender('041676ff', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Charts/SensorBarChart.vue"
export default component.exports